/* MUTATION TYPES
-------------------------------------------------------------- */
export const SET_THEME = 'SET_THEME';
export const SET_THEME_STYLES = 'SET_THEME_STYLES';
